import { createSelector } from 'reselect';
import { uiSelector } from '../common/state/selectors/issue-selector.tsx';

export const proformaSelector = createSelector(uiSelector, (ui) => ui.proforma);

export const isFormInEditModeSelector = createSelector(
	proformaSelector,
	(proforma) => !!proforma.isProformaFormInEditMode,
);
